import React from "react";
import {
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from "react-icons/fa";

const CustomPagination = ({
  currentPage,
  totalCount,
  pageSize,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    let startPage, endPage;

    if (totalPages <= 3) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();

  const buttonStyle =
    "h-9 w-9 flex items-center justify-center rounded-lg text-sm transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
  const activeButtonStyle = "bg-indigo-500 text-white font-bold shadow";
  const inactiveButtonStyle = "bg-gray-200 text-gray-700 hover:bg-indigo-100";
  const iconButtonStyle = "bg-gray-100 text-gray-600 hover:bg-indigo-100";

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
        className={`${buttonStyle} ${iconButtonStyle}`}
        aria-label="İlk Sayfa"
      >
        <FaAngleDoubleLeft />
      </button>
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`${buttonStyle} ${iconButtonStyle}`}
        aria-label="Önceki Sayfa"
      >
        <FaAngleLeft />
      </button>

      {pageNumbers.map((number) => (
        <button
          key={number}
          onClick={() => handlePageChange(number)}
          className={`${buttonStyle} ${
            currentPage === number ? activeButtonStyle : inactiveButtonStyle
          }`}
        >
          {number}
        </button>
      ))}

      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`${buttonStyle} ${iconButtonStyle}`}
        aria-label="Sonraki Sayfa"
      >
        <FaAngleRight />
      </button>
      <button
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages}
        className={`${buttonStyle} ${iconButtonStyle}`}
        aria-label="Son Sayfa"
      >
        <FaAngleDoubleRight />
      </button>
    </div>
  );
};

export default CustomPagination;
